import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Attach bearer token (fallback when cookies are blocked/partitioned)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ra_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const branch = localStorage.getItem("ra_branch");
  if (branch) config.headers["X-Branch-Id"] = branch;
  return config;
});

export function setBranch(id) {
  if (id) localStorage.setItem("ra_branch", id);
  else localStorage.removeItem("ra_branch");
}

export function setToken(token) {
  if (token) localStorage.setItem("ra_token", token);
  else localStorage.removeItem("ra_token");
}

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatIDR = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(
    Number(n || 0)
  );

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

const WA_STATUS_LABEL = { baru: "Baru", diproses: "Diproses", dikirim: "Dikirim", selesai: "Selesai", dibatalkan: "Dibatalkan" };
const WA_PAYMENT_LABEL = { belum_bayar: "Belum Bayar", dp: "DP", lunas: "Lunas" };

export const normalizePhone = (p) => {
  let d = (p || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("0")) d = "62" + d.slice(1);
  else if (d.startsWith("8")) d = "62" + d;
  return d;
};

export const buildWaUrl = (o) => {
  const phone = normalizePhone(o.father_phone || o.customer_phone);
  const dp = Number(o.down_payment) || 0;
  const remaining = Math.max(0, (o.total_amount || 0) - dp);
  const slaughter = { disaksikan: "Disaksikan langsung", video_call: "Video call", dokumentasi: "Dokumentasi" }[o.slaughter_option] || o.slaughter_option || "-";
  const lines = [
    "*RIZQIA AQIQAH*",
    `Nota: ${o.order_number}`,
    "",
    `Assalamu'alaikum ${o.father_name || o.customer_name || ""},`,
    "Berikut rincian pesanan aqiqah Anda:",
    "",
    `Nama Anak: ${o.child_name || o.aqiqah_name || "-"}`,
    o.child_birth ? `Tempat/Tgl Lahir: ${o.child_birth}` : null,
    (o.child_gender || o.gender) ? `Jenis Kelamin: ${o.child_gender || o.gender}` : null,
    "",
    `Jadwal Aqiqah: ${formatDate(o.event_date || o.schedule_date)}${o.event_time ? " pukul " + o.event_time : ""}`,
    o.delivery_time ? `Jam tiba kiriman: ${o.delivery_time}` : null,
    o.delivery_address ? `Alamat: ${o.delivery_address}` : null,
    "",
    `Pesanan: ${o.lamb_type || "Aqiqah"}${o.lamb_sex ? " (" + o.lamb_sex + ")" : ""} x ${o.lamb_count || 1} ekor`,
    o.rice_box_type ? `Nasi box: ${o.rice_box_type} x ${o.box_count || 0} box` : null,
    o.sate_per_box ? `Isi sate/box: ${o.sate_per_box}` : null,
    `Penyembelihan: ${slaughter}`,
    "",
    `Total: ${formatIDR(o.total_amount)}`,
    dp ? `DP: ${formatIDR(dp)}` : null,
    dp ? `Sisa: ${formatIDR(remaining)}` : null,
    `Pembayaran: ${WA_PAYMENT_LABEL[o.payment_status] || o.payment_status}`,
    "",
    "Terima kasih atas kepercayaan Anda kepada Rizqia Aqiqah.",
    "Barakallahu fiikum.",
  ].filter((l) => l !== null);
  const text = encodeURIComponent(lines.join("\n"));
  return phone ? `https://wa.me/${phone}?text=${text}` : `https://wa.me/?text=${text}`;
};

export default api;
